export default "__VITE_ASSET__b8bb2cb9__"